import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidResponseQuery, BidResponseRequest } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const BID_RESPONSE_QUERY = graphql(`
  query BidResponse($request: BidResponseRequest!) {
    bidResponse(BidResponseRequest: $request) {
      id
      bid {
        id
        name
      }
      reference
      title
      section
      description
      weighting
      formattingRequirements
      response
      teamId
      companyId
      stageId
      assignee {
        guid
        firstName
        lastName
      }
      reviewer {
        guid
        firstName
        lastName
      }
      dueDate
      createdAt
      updatedAt
      deletedAt
      changes {
        id
        responseId
        diff
        createdById
        createdAt
      }
      source {
        documentId
        title
        locations {
          pageNumber
          chunkNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
    }
  }
`);

export type BidResponseDto = NonNullable<BidResponseQuery["bidResponse"]>;

export function useBidResponse(
  request: BidResponseRequest,
  options?: UseQueryOptions<BidResponseQuery, unknown, BidResponseQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["bidResponse", request.id],
    BID_RESPONSE_QUERY,
    [{ request }],
    options,
  );

  return { data: data?.bidResponse, ...rest };
}
